import { useForm, Controller } from "react-hook-form";

const withUseFormHook = (Component, isAutomation = false) => {
    return props => {
        const form = useForm();
        if(isAutomation){
            const cform = useForm();
            return <Component {...props} useForm={form} useCForm={cform} controller={Controller} />
        }
        return <Component {...props} useForm={form} controller={Controller} />
    }
}
export default withUseFormHook;
